import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk, AppDispatch } from '../appStore'
import { IAppModal } from '../../common/types';

interface INavbarContent {
    leftButtonName:string
}

interface IBookingToast {
    message: string,
    open: boolean
}

interface IAppState {
    isNavbarVisible: boolean,
    navbarContent: INavbarContent | null,
    appModalState: IAppModal
    bookingToast: IBookingToast | null
}

const initialState: IAppState = {
    isNavbarVisible: false,
    appModalState: { message: '', title: '', isAppModalOpened: false },
    bookingToast: { message: '', open: false },
    navbarContent: {
        leftButtonName:"leftButtonName"
    }
}

const appStateSlice = createSlice({
    name: 'appState',
    initialState,
    reducers: {
        showNavbar(state: IAppState, action: PayloadAction<boolean>) {
            state.isNavbarVisible = action.payload;
        },
        showBookingToast(state: IAppState, action: PayloadAction<IBookingToast>) {
            state.bookingToast = { open: action.payload.open, message: action.payload.message };
        },
        showAppModal(state: IAppState, action: PayloadAction<IAppModal>) {
            state.appModalState.isAppModalOpened = action.payload.isAppModalOpened;
            if (action.payload.isAppModalOpened) {
                state.appModalState = { ...action.payload};
            } else {
                state.appModalState.message = '';
                state.appModalState.title = '';
            }
        },
    }
});


export const { showNavbar, showAppModal, showBookingToast } = appStateSlice.actions;

export default appStateSlice.reducer;